<template>
  <div class="row">
    <div class="col-lg-3">
      <h2>{{ $t('home.search') }}</h2>
      <div class="form-group">
        <input
          type="search"
          class="form-control"
          id="search"
          v-model="search"
          v-bind:placeholder="$t('home.search-placeholder')"
        />
      </div>
      <h2 class="mt-5">{{ $t('home.status') }}</h2>
      <ul class="list-group list-group-flush mb-5">
        <li class="list-group-item">
          <a
            @click="changeList(filteredList, 'all')"
            :class="{ active: active === 'all' }"
            >{{ $t('home.devices-all') }} <span>{{ all }}/{{ count }}</span></a
          >
        </li>
        <li class="list-group-item">
          <a
            @click="changeList(onlineList, 'online')"
            :class="{ active: active === 'online' }"
            >{{ $t('home.devices-online') }}
            <span>{{ online }}/{{ count }}</span></a
          >
        </li>
        <li class="list-group-item">
          <a
            @click="changeList(offlineList, 'offline')"
            :class="{ active: active === 'offline' }"
            >{{ $t('home.devices-offline') }}
            <span>{{ offline }}/{{ count }}</span></a
          >
        </li>
        <li class="list-group-item">
          <a
            @click="changeList(almostEmptyList, 'almost-empty')"
            :class="{ active: active === 'almost-empty' }"
            >{{ $t('home.cartridge-almost-empty') }}
            <span>{{ almostEmpty }}/{{ count }}</span></a
          >
        </li>
        <li class="list-group-item">
          <a
            @click="changeList(emptyList, 'empty')"
            :class="{ active: active === 'empty' }"
            >{{ $t('home.cartridge-empty') }}
            <span>{{ empty }}/{{ count }}</span></a
          >
        </li>
      </ul>
    </div>
    <Hubs v-show="displayedList.length" :hubs="displayedList" />
  </div>
</template>
<script>
// @ is an alias to /src
import Hubs from '@/components/Hubs.vue';
import { Action, Getter } from '@/store/hubs/types';

export default {
  name: 'Home',
  components: {
    Hubs,
  },
  data() {
    return {
      search: '',
      displayedList: [],
      active: 'all',
    };
  },
  computed: {
    hubs() {
      return this.$store.getters[`${Getter.DEVICES}`];
    },
    count() {
      return this.hubs.length;
    },
    all() {
      return this.filteredList.length;
    },
    online() {
      return this.onlineList.length;
    },
    offline() {
      return this.offlineList.length;
    },
    almostEmpty() {
      return this.almostEmptyList.length;
    },
    empty() {
      return this.emptyList.length;
    },
    onlineList() {
      return this.filteredList.filter((item) => {
        return item.online;
      });
    },
    offlineList() {
      return this.filteredList.filter((item) => {
        return !item.online;
      });
    },
    almostEmptyList() {
      return this.filteredList.filter((item) => {
        return item.cartridgeFill === 'almost-empty';
      });
    },
    emptyList() {
      return this.filteredList.filter((item) => {
        return item.cartridgeFill === 'empty';
      });
    },
    filteredList() {
      return this.hubs.filter((item) => {
        if (item.title !== null) {
          return item.title.toLowerCase().includes(this.search.toLowerCase());
        } else {
          return false;
        }
      });
    },
  },
  created() {
    this.getHubs();
    this.displayedList = this.filteredList;
  },
  watch: {
    search() {
      this.displayedList = this.filteredList;
    },
    filteredList() {
      this.displayedList = this.filteredList;
    },
  },
  methods: {
    getHubs() {
      this.$store.dispatch(`${Action.GET_DEVICES}`);
    },
    changeList(value, active) {
      this.active = active;
      this.displayedList = value;
    },
  },
};
</script>

<style scoped lang="scss">
a.active {
  color: $primary-color;
}
</style>
